import { render, staticRenderFns } from "./ENotificacoesList.vue?vue&type=template&id=8d5d546a&scoped=true"
import script from "./ENotificacoesList.vue?vue&type=script&lang=js"
export * from "./ENotificacoesList.vue?vue&type=script&lang=js"
import style0 from "./ENotificacoesList.vue?vue&type=style&index=0&id=8d5d546a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5d546a",
  null
  
)

export default component.exports